import { canCreateNewApp } from './states';

export const services = {
  canCreateNewApp,
};
